var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.voltages),function(item,index){return _c('Board',{key:index,attrs:{"index":index,"boardName":item.BoardName,"parameters":item.Parameters}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }